import React from 'react';
import Styled from 'styled';
import { Query } from '@apollo/client/react/components';

import InfoSettings from './info-settings/info-settings';
import ModeratorsSettings from './moderators-settings/moderators-settings';
import BlockingSettings from './blocking-settings/blocking-settings';
import query, { GroupSettingsQuery, GroupSettingsQueryVariables } from './group-settings.graphql';
import defaultStyles from './group-settings.scss';

export interface Props {
    styles: typeof defaultStyles;
    id: string;
}

class GroupSettings extends React.PureComponent<Props> {
    render() {
        const { styles, id } = this.props;
        return (
            <Query<GroupSettingsQuery, GroupSettingsQueryVariables>
                query={query}
                variables={{ id }}
                fetchPolicy='cache-first'
            >
                {({ data }) =>
                    data && data.group ? (
                        <div className={styles.wrapper}>
                            <InfoSettings {...data.group} />
                            <ModeratorsSettings {...data.group} />
                            <BlockingSettings {...data.group} />
                        </div>
                    ) : null
                }
            </Query>
        );
    }
}

export default Styled(defaultStyles)(GroupSettings);
